import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from "../views/Home";
import Compile from "../views/compile"
import CompileHome from "../components/compile/compileHome.vue"
import FeedingStyle from "../components/FeedingStyle/FeedingStyle.vue"
import BlenderStyle from "../components/blenderStyle/blenderStyle.vue"
import CoaterStyle from "../components/coaterStyle/coaterStyle.vue"
import RollerpressStyle from "../components/rollerpressStyle/rollerpressStyle.vue"
import SlittingStyle from "../components/slittingsStyle/slittingStyle.vue"
import CuttingStyle from "../components/cuttingStyle/cuttingStyle.vue"
import AutomaticStyle from "../components/automaticStyle/automaticStyle.vue"
import PrewelderStyle from "../components/prewelderStyle/prewelderStyle.vue"
import WelderStyle from "../components/welderStyle/welderStyle.vue"
import SealStyle from "../components/sealStyle/sealStyle.vue"
import RoasterStyle  from "../components/roasterStyle/roasterStyle.vue"
import FillingStyle from "../components/fillingStyle/fillingStyle.vue"
import FormationStyle from "../components/formationStyle/formationStyle.vue"
import CapperStyle from "../components/capperStyle/capperStyle.vue"
import WinderStyle from "../components/winderStyle/winderStyle.vue"
import loseStyle from "../components/loseStyle/loseStyle.vue"
import Login from "../views/Login/login.vue"
import machine_animation from "../components/nav-machine_animation/machine_animation.vue"
Vue.use(VueRouter)

const routes = [
  {
    path: "/login",
    name: "Login",
    component: Login
  },
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/compile/index",
    name: "Compile",
    component: Compile,
    redirect:{name:'Compile'},
    children:
    [
      {
        path: "/compile/home",
        name: "CompileHome",
        component: CompileHome,
        meta:{
          title:"主页数据"
        }
      },
      {
        path: "/feedingStyle",
        name: "FeedingStyle",
        component: FeedingStyle,
        meta:{
          title:"上料系统"
        }
      },
      {
        path: "/blenderStyle",
        name: "BlenderStyle",
        component: BlenderStyle,
        meta:{
          title:"搅拌机"
        }
      },
      {
        path: "/coaterStyle",
        name: "CoaterStyle",
        component:CoaterStyle,
        meta:{
          title:"涂布机"
        }
      },
      {
        path: "/rollerpressStyle",
        name: "RollerpressStyle",
        component:RollerpressStyle,
        meta:{
          title:"辊压机"
        }
      },
      {
        path: "/slittingStyle",
        name: "SlittingStyle",
        component:SlittingStyle,
        meta:{
          title:"分条机"
        }
      },
      {
        path: "/cuttingStyle",
        name: "CuttingStyle",
        component:CuttingStyle,
        meta:{
          title:"模切机"
        }
      },
      {
        path: "/automaticStyle",
        name: "AutomaticStyle",
        component:AutomaticStyle,
        meta:{
          title:"叠片机"
        }
      },
      {
        path: "/prewelderStyle",
        name: "PrewelderStyle",
        component:PrewelderStyle,
        meta:{
          title:"预焊机"
        }
      },
      {
        path: "/welderStyle",
        name: "WelderStyle",
        component:WelderStyle,
        meta:{
          title:"终焊机"
        }
      },
      {
        path: "/sealStyle",
        name: "SealStyle",
        component:SealStyle,
        meta:{
          title:"封口测试一体机"
        }
      },
      {
        path: "/roasterStyle",
        name: "RoasterStyle",
        component:RoasterStyle,
        meta:{
          title:"烘烤机"
        }
      },
      {
        path: "/fillingStyle",
        name: "FillingStyle",
        component:FillingStyle,
        meta:{
          title:"注液预封机"
        }
      },
      {
        path: "/formationStyle",
        name: "FormationStyle",
        component:FormationStyle,
        meta:{
          title:"化成机"
        }
      },
      {
        path: "/capperStyle",
        name: "CapperStyle",
        component:CapperStyle,
        meta:{
          title:"抽气二封机"
        }
      },
      {
        path: "/winderStyle",
        name: "WinderStyle",
        component:WinderStyle,
        meta:{
          title:"卷绕机"
        }
      },
      {
        path: "/loseStyle",
        name: "loseStyle",
        component:loseStyle,
        meta:{
          title:"负压化成机"
        }
      },
      {
        path: "/machine_animation",
        name: "machine_animation",
        component:machine_animation,
        meta:{
          title:"机器动画开关"
        }
      },
    ]
  }, 
]

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  let token = sessionStorage.getItem("listInfo") ? JSON.parse(sessionStorage.getItem("listInfo")) : false;

  if (token) {
    if (to.path == "/login") {
      next(false)
    } else {
      next()
    }
  } else {
    if (to.path == "/login") {
      next()
    } else {
      next("/login")
    }
  }
})

export default router
